import React, { useState } from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { mobileMenuButton, viewMenuButton } from 'images'
import MenuModal from './MenuModal'
import { dispatch } from 'store'

export default () => {
  const [showModal, setShowModal] = useState(false)
  return (
    <CFSelect selector={dispatch.restaurant.getPdfMenuUrl}>
      {pdfMenuUrl => (
        <CFView>
          <MobileScreen>
            <CFView
              hover
              onClick={() => setShowModal(true)}
              column
              center
              mt="8px"
              mb="15px"
            >
              <CFImage src={mobileMenuButton} maxWidth="65vw" alt="About" />
            </CFView>
          </MobileScreen>
          <DefaultScreen>
            <CFView hover onClick={() => setShowModal(true)} column center>
              <CFImage
                src={viewMenuButton}
                w="100%"
                maxWidth="210px"
                alt="About"
              />
            </CFView>
          </DefaultScreen>
          <MenuModal
            showModal={showModal}
            onRequestClose={() => setShowModal(false)}
          />
        </CFView>
      )}
    </CFSelect>
  )
}
